import { render, staticRenderFns } from "./FormLecture.vue?vue&type=template&id=054166bd&scoped=true&"
import script from "./FormLecture.vue?vue&type=script&lang=js&"
export * from "./FormLecture.vue?vue&type=script&lang=js&"
import style0 from "./FormLecture.vue?vue&type=style&index=0&id=054166bd&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "054166bd",
  null
  
)

export default component.exports